<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgements">
<h1>Acknowledgements</h1>
<p style="text-align:center">Thanks to Austin Macaulay Publishers for their help with this book.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?dfda946a